export function isStreamErrorType (type) {
    return type === 'error' || (typeof type === 'string' && type.endsWith('_error'));
}

export function streamErrorFromEvent (data) {
    const err = new Error(data.error?.body?.error || 'Stream error occurred');
    err.code = data.error?.code ?? 500;
    err.type = data.type || 'error';
    err.details = data;

    return err;
}

export function getStreamErrorMessage ($t, conversationId, error) {
    // eslint-disable-next-line no-console
    console.warn('Leo response failed:', {
        conversationId,
        type: error?.type,
        code: error?.code,
        message: error?.message,
        details: error?.details,
    });

    if (error?.type === 'timeout_error') {
        return $t('askPendo.errors.This request took too long to complete. Try a shorter date range, or ask one question at a time.');
    }

    return $t('askPendo.errors.Something went wrong while generating this response. Ask again, or try rewording your question.');
}
